import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@revvsales/components";
import esignError from "../../../assets/esign-error.gif";

import { EVENTS } from "../../../constants";
import { AmplitudeUtils } from "../../../utils/index";

class EsignatureErrorPopup extends Component {
  componentDidMount() {
    AmplitudeUtils.amplitudeLogEvent(
      EVENTS.EVENT_NAMES.SIGNATURE_BLOCK_MISSED,
      {
        ...this.props.document,
      },
    );
  }

  _closeEsignErrorModal = () => {
    this.props.togglePopUp("showESignErrorPopup", false);
  };

  render() {
    return (
      <Modal
        classNames={{ modal: "esign-error-modal" }}
        open
        onClose={this._closeEsignErrorModal}
        showCloseIcon={false}
        closeOnOverlayClick={false}
        center>
        <div className="signature-envelope-wrapper">
          <div className="popup-header">Prepare the doc for signature</div>
          <div className="esign-error-wrapper row">
            <div className="col-md-3">
              <div className="esign-error-instruction">
                <div className="esign-error-number">1</div>
                Select a signer name
                <i className="esign-error-arrow">
                  <FontAwesomeIcon icon={["far", "chevron-double-right"]} />
                </i>
              </div>
            </div>
            <div className="col-md-6">
              <div className="esign-error-instruction">
                <div className="esign-error-number">2</div>
                Drag the {"signature"} field and drop it to the desired location
                on the doc.This will serve as the placeholder
                <i className="esign-error-arrow">
                  <FontAwesomeIcon icon={["far", "chevron-double-right"]} />
                </i>
              </div>
            </div>
            <div className="col-md-3">
              <div className="esign-error-instruction">
                <div className="esign-error-number">3</div>Click {"Share"}
              </div>
            </div>
          </div>
          <div className="esign-error-video">
            {/* <video width="320" height="240" controls>
            <source src={esignError} type="video/mp4" />
            Your browser does not support the video tag.
          </video> */}
            <img src={esignError} alt="Help related to esign" />
          </div>
        </div>
        <div className="addproduct-footer">
          <div className="addproduct-footer-actions">
            <Button
              className="ok-btn"
              onClick={() => this.props.togglePopUp("esign-error", false)}
              data-test="esignatureerrorpopup-ok-btn">
              Ok
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default EsignatureErrorPopup;



// WEBPACK FOOTER //
// ./src/components/QuotationTopbar/QuotationTopbarBtns/EsignatureErrorPopup.js